import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export const AUTH_INPUT_CLS = "w-full bg-[#050505] border border-white/10 rounded-md px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-white/30 focus:ring-2 focus:ring-white/10 transition-all";
export const AUTH_BUTTON_CLS = "w-full mt-3 px-4 py-2.5 rounded-md bg-[#7C3AED] hover:bg-[#6928d6] disabled:opacity-50 text-white text-sm font-medium transition-colors";

/** Dark card shell shared by the public auth pages (forgot / reset / init). */
export function AuthShell({ kicker, title, children, testId }) {
    return (
        <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-4 py-10" data-testid={testId}>
            <div className="w-full max-w-md bg-[#0c0c10] border border-white/10 rounded-2xl p-8">
                <div className="flex items-center gap-3 mb-6">
                    <div
                        className="w-10 h-10 rounded-lg flex items-center justify-center font-display text-white text-lg font-extrabold tracking-tight"
                        style={{ background: "linear-gradient(135deg,#a17bff 0%,#7C3AED 55%,#4c1d95 100%)" }}
                    >
                        Ai
                    </div>
                    <div>
                        <div className="font-display text-lg tracking-tight">AIService</div>
                        <div className="text-[10px] uppercase tracking-[0.18em] text-white/40">{kicker}</div>
                    </div>
                </div>
                {title ? <h1 className="text-xl font-display tracking-tight mb-4">{title}</h1> : null}
                {children}
            </div>
        </div>
    );
}

export function AuthError({ message, testId = "auth-error" }) {
    if (!message) return null;
    return (
        <div className="text-xs text-red-300 border border-red-500/30 bg-red-500/10 rounded-md px-3 py-2 flex gap-2" data-testid={testId}>
            <AlertTriangle className="w-4 h-4 shrink-0 text-red-400" strokeWidth={1.6} />
            <span>{message}</span>
        </div>
    );
}

export function BackToLogin({ testId = "back-to-login" }) {
    const navigate = useNavigate();
    return (
        <button type="button" onClick={() => navigate("/login")} className="text-xs text-[#a17bff] hover:text-[#c7a6ff]" data-testid={testId}>
            ← Back to sign in
        </button>
    );
}

export const PASSWORD_HINT = "At least 12 characters with upper + lower case, a digit and a symbol.";
